export default {
  messages: {
    uk: {
      'Інспектори AUTO.RIA виїдуть до авто, перевірять його і надішлють звіт з фото та відео': 'Інспектори AUTO.RIA виїдуть до авто, перевірять його і надішлють звіт з фото та відео',
      'Всього до сплати:': 'Всього до сплати:',
      'Вид звіту': 'Вид звіту',
      'Приклад звіту': 'Приклад звіту',
      'Компютерна діагностика': 'Комп\'ютерна діагностика',
      'Поверхневий огляд двигуна': 'Поверхневий огляд двигуна',
      'Перевірка кузова': 'Перевірка кузова',
      'Огляд салону': 'Огляд салону',
      'Перевірка світлових приладів': 'Перевірка світлових приладів',
      'Огляд шин та дисків': 'Огляд шин та дисків',
      'Фото та відеозвіт': 'Фото та відеозвіт',
      'Замовити перевірку': 'Замовити перевірку',

    },
    ru: {
      'Інспектори AUTO.RIA виїдуть до авто, перевірять його і надішлють звіт з фото та відео': 'Инспекторы AUTO.RIA выедут в авто, проверят его и отправят отчет по фото и видео',
      'Всього до сплати:': 'Всего к оплате:',
      'Вид звіту': 'Вид отчета',
      'Приклад звіту': 'Пример отчета',
      'Компютерна діагностика': 'Компьютерная диагностика',
      'Поверхневий огляд двигуна': 'Поверхностный осмотр двигателя',
      'Перевірка кузова': 'Проверка кузова',
      'Огляд салону': 'Осмотр салона',
      'Перевірка світлових приладів': 'Проверка световых приборов',
      'Огляд шин та дисків': 'Осмотр шин и дисков',
      'Фото та відеозвіт': 'Фото и видеоотчет',
      'Замовити перевірку': 'Заказать проверку',
    },
  },
};
